import React from "react";
import Lookbook from "./lookbook";

const images = [
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/1.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/2.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/3.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/4.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/5.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/6.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/7.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/8.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/9.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/10.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/11.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/12.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/13.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/14.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/15.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/16.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/17.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/18.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/19.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/20.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/21.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/22.jpg",
  "https://ik.imagekit.io/nlmcdn/DEEDAT/LookBook/23.jpg",

  // Add more image URLs as needed
];
function App() {
  return (
    <div className="flex flex-col justify-center md:px-14 px-2 bg-black">
      <div className="flex flex-col py-1 text-center justify-center">
        <div className="flex justify-center">
          <img src="/deedat_w.png" alt="logo" className="w-[350px]" />
        </div>

        <h1 className="text-3xl font-bold tracking-wider text-white">
          LOOK BOOK
        </h1>
      </div>
      <div className="flex flex-col w-full items-center">
        <video
          src="https://ik.imagekit.io/nlmcdn/DEEDAT/banner.mp4"
          autoPlay={true}
          loop={true}
          muted={true}
          className="w-[1280px] rounded-3xl h-[720px]"
        />
        <div className="flex flex-col justify-center items-center relative bottom-16">
          <img
            src="/arrow-down.gif"
            alt="arrow"
            className="w-[100px] z-1000  "
          />
          <p className="text-white text-2xl font-light uppercase animate-ping duration-300 pl-4">
            Scroll Down
          </p>
        </div>
      </div>
      <div className="container mx-auto p-2">
        <Lookbook images={images} />
      </div>
    </div>
  );
}

export default App;
